(function() {
'use strict';

angular.module('TR')
    .service('cancellerService', cancellerService);

function cancellerService($q, $timeout, broker) {
    let supervisors = [];

    const service = {
        add,
        process: processFunc
    };

    function add(...validRoutes) {
        const supervisor = { validRoutes, canceller: $q.defer() };
        supervisors.push(supervisor);
        return supervisor.canceller;
    }

    function processFunc(nextRoute) {
        const remainingSupervisors = [];
        supervisors.forEach(function(s) {
            const valid = s.validRoutes.some(function(r) {
                if (r instanceof RegExp) {
                    return r.test(nextRoute);
                }
                return r === nextRoute;
            });

            if (!valid) {
                const delay = TRPCONFIG.Domain.EnableHolidaySearchForceLoading ? 2000 : 0;
                $timeout(() => { broker.publish('unblock'); }, delay);
                s.canceller.resolve('CANCELLED');
            } else {
                remainingSupervisors.push(s);
            }
        });

        supervisors = remainingSupervisors;
    }

    return service;
}
})();
